import type { ReachApiResponse } from '../../ReachApi/ReachAPI';
import { z } from 'zod';
import {
    WidgetType,
    ZodBaseWidgetConfiguration,
    ZodGenericWidgetConfigurationDetails,
} from '../types';

export const ZodTickerWidgetConfigurationDetails = ZodGenericWidgetConfigurationDetails.extend({
    node: z.string(),
    feedurl: z.string(),
    disable_scroll: z.string(),
    scroll_speed: z.string(),
    feed_type: z.string(),
    service: z.string(),
    profile_id: z.string(),
    posts: z.string(),
    timezone: z.string(),
    parsing_sugar: z.string(),
    url_fetcher_id: z.string(),
    disable_hardware: z.string(),
    text_only: z.string(),
});

export type TickerWidgetConfigurationDetails = z.infer<typeof ZodTickerWidgetConfigurationDetails>;

export const ZodTickerWidgetConfiguration = ZodBaseWidgetConfiguration.extend({
    type: z.literal(WidgetType.TICKER),
    config: ZodTickerWidgetConfigurationDetails,
});

export type TickerWidgetConfiguration = z.infer<typeof ZodTickerWidgetConfiguration>;

export interface ReachAPIGetTickerFeedResponse extends ReachApiResponse {
    feed: {
        sources: unknown;
        items: TickerFeedItem[];
    };
}

export type TickerFeedItem = {
    title: string;
    description: string;
};

export type TickerFeed = {
    channel: {
        item: TickerFeedItem[];
    };
};

export type TickerTemplateData = {
    Widget: { Id: number };
    wobj: {
        widget: {
            widgetsid: number;
            config: {
                css: string | null;
            };
        };
    };
    wid: number;
    node: string;
    stories: TickerFeedItem[];
};
